import {
  keepPreviousData,
  type QueryClient,
  useQuery,
} from "@tanstack/react-query";

import useApi from "../../api/apiConfig";
import {
  type InsuranceVerificationSearchParams,
  searchInsuranceVerifications,
} from "./api";

export const IV_KEY = ["insurance-verifications"];
export const IV_LIST_KEY = [...IV_KEY, "list"];

export const ivListQueryKey = (params: InsuranceVerificationSearchParams) => [
  ...IV_LIST_KEY,
  params,
];

export function useInsuranceVerificationList(
  params: InsuranceVerificationSearchParams,
) {
  const { getClient } = useApi();
  return useQuery({
    queryKey: ivListQueryKey(params),
    queryFn: async ({ signal }) =>
      searchInsuranceVerifications(await getClient(), params, signal),
    placeholderData: keepPreviousData,
    staleTime: 0,
  });
}

export function patchInsuranceVerification(
  queryClient: QueryClient,
  wieldyId: string,
  update: (
    verification: InsuranceVerificationMessage,
  ) => InsuranceVerificationMessage,
) {
  queryClient.setQueriesData<SearchResponse>(
    { queryKey: IV_LIST_KEY },
    (old) => {
      if (!old?.data.some((v) => v.wieldyId === wieldyId)) return old;
      return {
        ...old,
        data: (old.data as InsuranceVerificationMessage[]).map((v) =>
          v.wieldyId === wieldyId ? update(v) : v,
        ),
      };
    },
  );
}
